import type React from "react";
import { RouterProvider } from "@/adapters/react-router/root-provider.tsx";
import { queryClient } from "@/adapters/tanstack-query/query-client.ts";
import { QueryProvider } from "@/adapters/tanstack-query/root-provider.tsx";
import { ErrorBoundary } from "@/components/error-boundary";
import { Toaster } from "@/components/ui/sonner.tsx";

export function Providers({ children }: { children: React.ReactNode }) {
	return (
		<RouterProvider>
			<QueryProvider queryClient={queryClient}>
				<ErrorBoundary>{children}</ErrorBoundary>
				<Toaster richColors position="top-right" />
			</QueryProvider>
		</RouterProvider>
	);
}
